import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV_LINKS, SUBSTACK_URL } from "../../mock/mock";

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#FFFDF6]/90 backdrop-blur-md border-b border-[#41232E]/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto flex items-center justify-between px-6 md:px-10 py-5">
        <a href="#top" className="flex items-center gap-2 group">
          <span className="w-2.5 h-2.5 rounded-full bg-[#605F26] group-hover:bg-[#D8D355] transition-colors duration-500"></span>
          <span className="font-serif-display text-[#41232E] text-xl md:text-[1.35rem] tracking-tight">
            The Owner&rsquo;s Mind
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="om-link text-[0.92rem] text-[#41232E]/85 hover:text-[#41232E] tracking-wide"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href={SUBSTACK_URL}
            target="_blank"
            rel="noreferrer"
            className="om-btn om-btn-primary text-sm"
          >
            Join me on Substack
          </a>
        </div>

        <button
          className="md:hidden text-[#41232E] p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#FFFDF6] border-t border-[#41232E]/10 px-6 py-6 space-y-4">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block text-[#41232E] text-lg font-serif-display"
            >
              {l.label}
            </a>
          ))}
          <a
            href={SUBSTACK_URL}
            target="_blank"
            rel="noreferrer"
            className="om-btn om-btn-primary w-full justify-center"
          >
            Join me on Substack
          </a>
        </div>
      )}
    </header>
  );
};

export default Nav;
